var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5301 17.0004L13.4801 12.9504M13.4801 12.9504C14.1302 12.3003 14.6458 11.5286 14.9976 10.6793C15.3494 9.82995 15.5305 8.91966 15.5305 8.00036C15.5305 7.08106 15.3494 6.17076 14.9976 5.32144C14.6458 4.47211 14.1302 3.7004 13.4801 3.05036C12.8301 2.40031 12.0584 1.88467 11.2091 1.53287C10.3597 1.18107 9.44944 1 8.53014 1C7.61084 1 6.70054 1.18107 5.85122 1.53287C5.0019 1.88467 4.23019 2.40031 3.58014 3.05036C2.26732 4.36318 1.52979 6.14375 1.52979 8.00036C1.52979 9.85697 2.26732 11.6375 3.58014 12.9504C4.89296 14.2632 6.67353 15.0007 8.53014 15.0007C10.3868 15.0007 12.1673 14.2632 13.4801 12.9504Z",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5cce58534b238a54a5b9ce69c303afb0.svg";
export { ForwardRef as ReactComponent };